import { getReleaseEnding } from "../../utils/utils";
import RatingStars from "../RatingStars";
import Typography from "../Typography";
import { useDispatch, useSelector } from "react-redux";
import {
  pause,
  playMedia,
  setCurrentContent,
} from "../../redux/Slice/playerSlice";
import { setPlaylistReleases } from "../../redux/Slice/playlistReleasesSlice";
import {
  DetailInfoContainer,
  PodcastInfo,
  PodcastRatingStar,
  TitleWrapper,
} from "./styled";
import { Button } from "../Button/Button";
import {
  selectCurrentContent,
  selectIsPlaying,
} from "../../redux/selectors/playerSelector";

import { TruncatedDescription } from "../TruncatedDescription/TruncatedDescription";
import { AdultIconWithTooltip } from "../AdultIconWithTooltip";

export const PodcastDetailInfo = ({ podcast }) => {
  const dispatch = useDispatch();
  const podcastReleases = podcast.podcastReleases;
  const currentContent = useSelector(selectCurrentContent);

  const isPlaying = useSelector(selectIsPlaying);

  const hasReleases = podcastReleases.length > 0;

  // Проигрываем последний добавленный выпуск подкаста
  const handlePlayClick = () => {
    if (!hasReleases) return;

    if (currentContent.id === podcastReleases[0].id && isPlaying) {
      dispatch(pause());
      return;
    }

    dispatch(setCurrentContent(podcastReleases[0]));
    dispatch(playMedia(podcastReleases[0].audioFileLink));
    dispatch(
      setPlaylistReleases(podcastReleases.filter((item) => !item.isLive)),
    );
  };

  return (
    <DetailInfoContainer>
      <TitleWrapper>
        <Typography variant="h2">{podcast.title}</Typography>
        {podcast.isAdult && <AdultIconWithTooltip />}
      </TitleWrapper>
      <PodcastInfo>
        <PodcastRatingStar src="/star.svg" alt={podcast.avgRating} />
        <Typography>
          {podcast.avgRating} ({podcast.countRatings})
        </Typography>
        •
        <Typography>
          {podcast.countPodcastReleases}{" "}
          {getReleaseEnding(podcast.countPodcastReleases)}
        </Typography>
      </PodcastInfo>

      <TruncatedDescription text={podcast.description} />

      <RatingStars initialRating={podcast.userRating} podcastId={podcast.id} />

      {hasReleases && (
        <Button variant="orange" type="button" onClick={handlePlayClick}>
          Последний выпуск
          {isPlaying && podcastReleases[0].id === currentContent.id ? (
            <img src="/pause.svg" alt="Пауза" width={16} height={16} />
          ) : (
            <img src="/play.svg" alt="Воспроизвести" width={16} height={16} />
          )}
        </Button>
      )}
    </DetailInfoContainer>
  );
};
